export const isBrowser = typeof window !== 'undefined' && window.document;

export const loadGoogleMapScript = (
  googleMapsScriptBaseUrl: string,
  googleMapsScriptUrl: string
): Promise<void> => {
  if (!isBrowser) return Promise.resolve();

  if (typeof google !== 'undefined') {
    if (google.maps && google.maps.places) return Promise.resolve();
  }

  const scriptElements = document.querySelectorAll(
    `script[src*="${googleMapsScriptBaseUrl}"]`
  );

  if (scriptElements && scriptElements.length) {
    return new Promise((resolve) => {
      if (typeof google !== 'undefined') return resolve();

      scriptElements[0].addEventListener('load', () => resolve());
    });
  }

  let scriptUrl = new URL(googleMapsScriptUrl);
  scriptUrl.searchParams.set(
    'callback',
    '__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__'
  );
  const el = document.createElement('script');
  el.src = scriptUrl.toString();

  return new Promise<void>((resolve) => {
    (window as any).__REACT_GOOGLE_AUTOCOMPLETE_CALLBACK__ = resolve;
    document.body.appendChild(el);
  });
};
